import React from 'react'

export default function Border() {
  return (
    <>
    <h1>Borders</h1>
    <p>There are several classes to quickly and easily apply border styles to elements, as well as control the border radius </p>
  
    <h2>Dark Borders</h2>
    <h3>Code:</h3>
    <div className='border-grey pl-1 border-curve bc-grey'>
        <p className='medium'>
          &lt;p class="border-dark"&gt;border-dark&lt;/p&gt;<br />
          &lt;p class="border-top-dark"&gt;border-top-dark&lt;/p&gt;<br />
          &lt;p class="border-left-dark"&gt;border-left-dark&lt;/p&gt;<br />
          &lt;p class="border-right-dark"&gt;border-right-dark&lt;/p&gt;<br />
          &lt;p class="border-bottom-dark"&gt;border-bottom-dark&lt;/p&gt;<br />
        </p>
    </div>

    <h3>Result:</h3>
    <div className='border-grey p-items-1 border-curve m-items-1'>
        <p className="border-dark">border-dark</p>
        <p className="border-top-dark">border-top-dark</p>
        <p className="border-left-dark">border-left-dark</p>
        <p className="border-right-dark">border-right-dark</p>
        <p className="border-bottom-dark">border-bottom-dark</p>
    </div>

    <h2>Grey Borders</h2>
    <h3>Code:</h3>
    <div className='border-grey pl-1 border-curve bc-grey'>
        <p className='medium'>
          &lt;p class="border-grey"&gt;border-grey&lt;/p&gt;<br />
          &lt;p class="border-top-grey"&gt;border-top-grey&lt;/p&gt;<br />
          &lt;p class="border-left-grey"&gt;border-left-grey&lt;/p&gt;<br />
          &lt;p class="border-right-grey"&gt;border-right-grey&lt;/p&gt;<br />
          &lt;p class="border-bottom-grey"&gt;border-bottom-grey&lt;/p&gt;<br />
        </p>
    </div>

    <h3>Result:</h3>
    <div className='border-grey p-items-1 border-curve m-items-1'>
        <p className="border-grey">border-grey</p>
        <p className="border-top-grey">border-top-grey</p>
        <p className="border-left-grey">border-left-grey</p>
        <p className="border-right-grey">border-right-grey</p>
        <p className="border-bottom-grey">border-bottom-grey</p>
    </div>

    <h2>light Borders</h2>
    <h3>Code:</h3>
    <div className='border-grey pl-1 border-curve bc-grey'>
        <p className='medium'>
          &lt;p class="border-light"&gt;border-light&lt;/p&gt;<br />
          &lt;p class="border-top-light"&gt;border-top-light&lt;/p&gt;<br />
          &lt;p class="border-left-light"&gt;border-left-light&lt;/p&gt;<br />
          &lt;p class="border-right-light"&gt;border-right-light&lt;/p&gt;<br />
          &lt;p class="border-bottom-light"&gt;border-bottom-light&lt;/p&gt;<br />
        </p>
    </div>

    <h3>Result:</h3>
    <p> This container has been set to dark to make the border visible</p>
    <div className='border-grey p-items-1 border-curve m-items-1 c-light bc-dark'>
        <p className="border-light">border-light</p>
        <p className="border-top-light">border-top-light</p>
        <p className="border-left-light">border-left-light</p>
        <p className="border-right-light">border-right-light</p>
        <p className="border-bottom-light">border-bottom-light</p>
    </div>

    <h2>Border Radius</h2>
    <h3>Code:</h3>
    <div className='border-grey pl-1 border-curve bc-grey'>
        <p className='medium'>
          &lt;span class="border-grey bc-blue border-round"&gt;border-round&lt;/span&gt;<br />
          &lt;span class="border-grey bc-blue border-curve"&gt;border-curve&lt;/span&gt;<br />
        </p>
    </div>

    <h3>Result:</h3>
    <div className='border-grey p-2 bold border-curve m-items-1 p-items-1'>
        <span className="border-grey bc-blue border-round">border-round</span>
        <span className="border-grey bc-blue border-curve">border-curve</span>
    </div>

  </>
  )
}
